import * as React from "react";
import * as ReactRedux from "react-redux";
import { navigateTo } from "gatsby-link";

interface DocFolderCellProps {
	title: string;
	children: any;
	// isInitiallyOpen: boolean;
}

/**
 * collapsable document folder cell for display in a page sidebar
 */
class DocFolderCellComponent extends React.Component<DocFolderCellProps, any> {
	state = {
		isOpen: true,
	};

	// componentDidMount() {
	// 	this.setState({ isOpen: this.props.isInitiallyOpen });
	// }

	// toggleOpen() {
	// 	this.setState({ isOpen: !this.state.isOpen });
	// }

	render() {
		const { title, children } = this.props;
		const { isOpen } = this.state;

		return (
			<div
				style={{
					color: isOpen ? "#363636" : "#636363",
					marginBottom: 20,
				}}
			>
				<div
					style={{
						display: "flex",
						paddingRight: 10,
						paddingTop: "0.5em",
						paddingBottom: 0,
						alignItems: "center",
						color: "#363636",
						marginTop: "2rem",
					}}
					// onClick={this.toggleOpen.bind(this)}
				>
					<h4 style={{ marginBottom: "0.5em" }}>{title}</h4>
				</div>

				<div
					style={{
						display: isOpen ? "block" : "none",
					}}
				>
					{children}
				</div>
			</div>
		);
	}
}

export default DocFolderCellComponent;



// WEBPACK FOOTER //
// ./src/components/DocFolderCell/DocFolderCell.tsx